export default __webpack_public_path__ + "static/N0218-f92e7c5dd5006a8759fd8f9de9be0126.png";